<template>
    <div class="animated fadeIn">
        <DynamicList
                ref="dynamicCardList"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                :onRetrieve="onRetrieve"
                root="/report/commerce-stocks"
                :searchArgs="searchArgs">

            <slot slot="afterSearchForm">
                <b-button @click="$refs.modalExport.open = true" variant="light" class="mb-3">
                    {{Core.Definition.getDefinition("Exporter sous format ...")}}
                </b-button>
                <ModalExport
                        ref="modalExport"
                        root="/report/commerce-stocks"
                        :formStructure="{
                                rows: [
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportFormat'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                     {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportTitle'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'id'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'title'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'type'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'stockManagement'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'stockQuantity'
                                                    }
                                                ]
                                            },
                                            {
                                            }
                                        ]
                                    }
                                ],
                                fields: [
                                    {
                                        id: 'exportFormat',
                                        type: 'select',
                                        options: Core.Export.formatOptions(),
                                        label: Core.Definition.getDefinition('Format'),
                                        value: null,
                                        onSelect: function() {}
                                    },
                                    {
                                        id: 'exportTitle',
                                        type: 'text',
                                        label: Core.Definition.getDefinition('Titre'),
                                        value: '',
                                        required: true
                                    },
                                    {
                                        id: 'id',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('ID'),
                                        value: true,
                                        export: 'id',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'stockManagement',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Gestion des stocks activées'),
                                        value: true,
                                         export: 'stockManagement',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'type',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Type de produit'),
                                        value: true,
                                         export: 'type',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'title',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Titre'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'title',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'stockQuantity',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Quantité'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'stockQuantity',
                                        onChange: function() {}
                                    }
                                ]}"

                @onSubmit="onExport">
                </ModalExport>
            </slot>
        </DynamicList>

    </div>
</template>

<script>
    import DynamicList from '../../../../components/DynamicList'
    import CardChartBar from '../../../../components/CardChartBar'
    import ModalExport from '../../../../components/ModalExport'
    export default {
        name: 'ReportCommerceStock',
        components: {
            DynamicList,
            CardChartBar,
            ModalExport
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataSearchArgs: [],
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Titre'),
                        key: 'title',
                        type: 'text',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Type'),
                        key: 'type',
                        type: 'select',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Gestion des stocks'),
                        key: 'stockManagement',
                        type: 'checkbox',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Quantité'),
                        key: 'stockQuantity',
                        type: 'number',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'title'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'stockManagement'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'stockQuantity'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            fields: [
                                {
                                    id: 'type'
                                }
                            ]
                        },
                        {},
                        {},
                        {}
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'text',
                            label: Core.Definition.getDefinition('ID'),
                        },
                        {
                            id: 'stockManagement',
                            type: 'checkbox',
                            label: Core.Definition.getDefinition('Gestion des stocks activées'),
                            onChange: function() {}
                        },
                        {
                            id: 'type',
                            type: 'select',
                            label: Core.Definition.getDefinition('Type'),
                            onSelect: function() {}
                        },
                        {
                            id: 'title',
                            type: 'text',
                            label: Core.Definition.getDefinition('Titre'),
                        },
                        {
                            id: 'stockQuantity',
                            type: 'number',
                            label: Core.Definition.getDefinition('Quantité'),
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                }
            }
        },
        methods: {
            onExport() {
                let searchArgs = this.$refs.dynamicCardList.$refs.request.dataArgs
                for(let searchArg in searchArgs) {
                    searchArg = searchArgs[searchArg]
                    this.$refs.modalExport.$refs.request.addArg(searchArg.key, searchArg.value, searchArg.type)
                }
            },
            onRetrieve(data) {
            },
            clickEdit(value, cell, row) {
                this.$router.push('/commerce/produits/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
